import { Grade } from './code-management';

export function getGrade(gradeCode: string, allGrades: Grade[]): Grade {
  return allGrades.find((grade) => grade.code === gradeCode);
}
